module.exports = __webpack_public_path__ + "static/img/alizaperry_circle150.e9e5706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/alizaperry_circle150.png
// module id = cNTi
// module chunks = 0